import {Stack, Typography} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function SoftwareDistributionDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const [softwareDistributionList, setSoftwareDistributionList] = useState(props.objList);
  const {defaultLanguage, mappings, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!softwareDistributionList || softwareDistributionList.length === 0) return null;

  return (
    <div>
      {/* Pivot Language Heading */}
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {softwareDistributionList.getObjList().map((item, index) => {
        return (
          <Stack key={index} sx={{pt: 1}} spacing={1}>
            {/* !isEmpty(item.accessLocation.getValue()) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.accessLocation, "accessLocation")}
                </Typography>
                <Typography variant="body1">{item.accessLocation.getValue()}</Typography>
              </div>
            )*/ }

            {/* !isEmpty(item.downloadLocation.getValue()) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.downloadLocation, "downloadLocation")}
                </Typography>
                <Typography variant="body1">{item.downloadLocation.getValue()}</Typography>
              </div>
            ) */}

            {/* !isEmpty(item.executionLocation.getValue()) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.executionLocation, "executionLocation")}
                </Typography>
                <Typography variant="body1">{item.executionLocation.getValue()}</Typography>
              </div>
            )*/ }

            {!isEmpty(getLabel(item.softwareDistributionForm.getValue())) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.softwareDistributionForm, "corpusSubclass")}
                </Typography>
                <Typography variant="body1">{getLabel(item.softwareDistributionForm.getValue())}</Typography>
              </div>
            )}

          </Stack>
        );
      })}


    </div>
  );
}
